import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2 } from './models/select2';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-select2',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        FormsModule
    ],
    templateUrl: './select2.component.html',
    styleUrls: ['./select2.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class Select2Component implements OnInit, OnChanges {
  @Output() selectedValueEmit = new EventEmitter<string>();
  @Input() model: Select2[];
  @Input() disable: boolean;
  @Input() isLoading: boolean;
  @Input() hasIcon: boolean;
  @Input() label = '';
  @Input() haveSearch: boolean;
  @Input() haveAllOption: boolean;
  @Input() selectedValue: any;
  selectedItem: any;
  searchValue = '';
  formControl = new FormControl();

  searchedModel = [];
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    this.searchedModel = this.model;
    if (changes.selectedValue) {
      if (!changes.selectedValue.currentValue) {
        this.selectedItem = null;
      } else {
        //   this.findSelectedItem(changes.selectedValue.currentValue);
      }
    }
  }

  ngOnInit(): void {
    this.searchedModel = this.model;
  }

  search(): void {
    const model = JSON.parse(JSON.stringify(this.model));
    this.searchedModel = [];
    model.forEach(element => {
      element.children = element.children.filter(x => x.name.includes(this.searchValue));
    });
    this.searchedModel = model;
  }

  onSelect(item): void {
    if (item.deactive) {
      return;
    }
    this.selectedItem = item;
    this.selectedValueEmit.emit(item.value);
  }

  emitEmpty(): void {
    this.selectedValueEmit.emit('');
    this.selectedItem = null;
  }

  trackByFn(index, item) {
    return index;
  }

}
